import {
  NameSpecifiedEntity
} from "../entity";

export class Profession extends NameSpecifiedEntity<string> {
  constructor(id: string, name: string, public category: string) {
    super(id, name);
  }
}
